var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// /Users/justinhannis/Work/FORUM/immigration-forum-theme/_CURRENT/immigration-forum/node_modules/lodash/_Symbol.js
// module id = 13
// module chunks = 0